import { UserX, ShieldQuestion } from "lucide-react";

/**
 * THE ONE PLACE a visit's doctor-ownership facts are rendered (§2 Session 4).
 *
 * Two facts, each drawn only when the row says so, and silent otherwise —
 * every visit written before this feature carries neither key, and absence
 * is "not asked", never "own doctor":
 * - `other_officers_doctor === true`: the call was logged on an ad hoc call
 *   to a doctor on a colleague's list. Named by owner, so a manager reading
 *   the team view knows whose doctor it was without opening the doctor.
 * - `doctor_pending_verification === true`: the doctor was added from the
 *   field on this call and the Admin Manager has not yet verified them.
 */
export default function OffListBadge({ visit, size = "sm" }) {
  if (!visit) return null;
  const text = size === "lg" ? "text-xs" : "text-[11px]";
  const icon = size === "lg" ? 13 : 11;
  const other = visit.other_officers_doctor === true;
  const pending = visit.doctor_pending_verification === true;
  if (!other && !pending) return null;
  return (
    <>
      {other && (
        <span
          className={`inline-flex items-center gap-1 rounded-full bg-sky-100 text-sky-900 px-2 py-0.5 ${text} font-semibold`}
          data-testid={`visit-other-officer-${visit.id}`}
          title={visit.doctor_owner_name ? `On ${visit.doctor_owner_name}'s list` : "On another officer's list"}
        >
          <UserX size={icon} className="shrink-0" />
          Other officer's doctor
          {visit.doctor_owner_name ? ` · ${visit.doctor_owner_name}` : ""}
        </span>
      )}
      {pending && (
        <span
          className={`inline-flex items-center gap-1 rounded-full bg-orange-100 text-orange-900 px-2 py-0.5 ${text} font-semibold`}
          data-testid={`visit-pending-doctor-${visit.id}`}
          title="Added from the field; awaiting the Admin Manager's verification"
        >
          <ShieldQuestion size={icon} className="shrink-0" />
          Doctor awaiting verification
        </span>
      )}
    </>
  );
}
